import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { AuthenticationService } from '../../user/_services/authentication.service';
import {FORM_MSGS} from '../../_common/product-config';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  @ViewChild("forgotForm", {static: false}) forgotForm: NgForm;

  private loading: boolean = false;
  private submitted:boolean = false;
  private error:string = '';

  private formMsgs = FORM_MSGS;

  constructor(private modalService : NgbActiveModal, private authenticationService: AuthenticationService) { }

  ngOnInit() {
  }

  onResetPassword(){
    if(this.forgotForm.valid && this.forgotForm['username'] != undefined){
      console.log(this.forgotForm);

      this.loading = true; 
      this.authenticationService.forgot(this.forgotForm['username']).subscribe(data=>{
        this.loading = false; 
        this.modalService.close({error: false});
      },
      error => {
          this.error = error;
          this.loading = false;
          this.modalService.close({error: true});
      });
    }
  }
}
